<template>
  <div class="exam-record">
    <common-breadcrumb2024/>
    <div class="main-container">
      <div class="main-title">
        <div class="top-left">您一共完成{{ examCount }}次考试，平均分为：{{ averageScore }}分，继续努力吧！您做题正确率为：<span>{{ accuracy }}%</span></div>
        <div class="top-right">排序：
          <el-select
            v-model="orderValue"
            @change="changeOrder"
            size="small">
            <el-option
              v-for="(item, idx) in orderOptions"
              :key="idx"
              :value="item.value"
              :label="item.label"/>
          </el-select>
        </div>
      </div>
      <div v-if="recordList" class="main-table">
        <el-table
          :data="recordList"
          stripe
          empty-text="暂无记录~"
        >
          <el-table-column
            prop="examName"
            label="考试记录"
            width="300"
            align="left"

            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="createTime"
            label="考试时间"
            min-width="150"
            align="center"
            :show-overflow-tooltip="true"/>
          <el-table-column
            prop="spendTime"
            label="用时"
            width="80"
            align="center"
            :show-overflow-tooltip="true"/>
          <!--<el-table-column
            prop="errorQuesNum"
            label="错题数"
            width="80"
            align="center"
            :show-overflow-tooltip="true"/>-->
          <el-table-column
            prop="lastScore"
            label="得分"
            width="80"
            align="center"
            class-name="score"
            :show-overflow-tooltip="true"/>
          <el-table-column
            label="操作"
            min-width="270"
            align="center" >
            <template slot-scope="scope">
              <!--<el-button size="mini" @click="parseQuestion(scope.row.bizID)">解析</el-button>-->
              <el-button size="mini" @click="parseQuestion(scope.row)">解析</el-button>
              <el-button size="mini" type="Success" @click="retryQuestion(scope.row.bizID)">重做</el-button>
              <el-button size="mini" type="danger" @click="deleteReport(scope.row.bizID)">删除记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="recordsParams.pageNum"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="recordsCount"/>
      </div>
    </div>
  </div>
</template>
<script>
  import { CommonBreadcrumb2024 } from '@components/common/'
  import { getRecordList, quesAnalyStatistics,deleteRecord } from '@/api'
  import { timestampToTime, secondsToMinutes,getCookie,LoadingOptions } from '@/utils'
  export default {
    name: 'examRecord',
    components: {
      CommonBreadcrumb2024
    },
    data() {
      return {
        loadingInstance: null,
        courseName:'mid',
        statisticsList: {},  //  考试综合统计数据
        recordList: null,
        recordsParams: {
          flag: this.flag,
          userID: Number(getCookie('cdeluid')) || null,
          pageNum: Number(new URLSearchParams(this.$route.fullPath).get('routerSourcePages')) || 1,
          pageSize: 7,
          orderType: 'desc',
          orderField: 'createTime',
          courseID: null,
          bizType: 2,
          source:'pc'
        },
        recordsCount: 0,
        pageSize: 10, //  页长
        totalPageNum: 1, //  总页数
        //其他
        siteCourseID: '',
        courseID: '',
        flag: '',
        orderValue: 'createTime,desc',  //  排序选项
        orderOptions: [
          {value: "createTime,desc", label: "时间倒序"},
          {value: "createTime,asc", label: "时间升序"},
          {value: "lastScore,desc", label: "分数倒序"},
          {value: "lastScore,asc", label: "分数升序"}]

      }
    },
    computed: {
      examCount () {  // 获取考试次数
        return this.statisticsList.total || 0
      },
      averageScore () {  // 获取平均分
        let result = this.statisticsList.sumScore / this.statisticsList.total || 0
        return Math.round(result * 100) / 100
      },
      accuracy () {  // 获取做题正确率
        let result = this.statisticsList.sumRightNum / this.statisticsList.sumQuesNum || 0
        return Math.round(result * 10000) / 100
      }
    },
    created(){
      this.initData()
      this.getStatisticsList()
      this.getRecordListFun()
    },
    methods:{
      initData() {
        const { flag } = this.$route.params
        this.flag = flag === 'paidExam' ? '' : flag
        let query = this.$route.query
        this.courseID = Number(query.courseID)
        this.siteCourseID = Number(query.siteCourseID)
        this.recordsParams.courseID = this.courseID
        //this.recordsParams.siteCourseID = this.siteCourseID
        this.recordsParams.flag = this.flag
      },
      // 查看用户统计数据
      async getStatisticsList() {
        let dataParams = {
          flag: this.flag,
          userID: Number(getCookie('cdeluid')) || null,
          courseID: this.courseID,
          bizType:2,
          source:'pc'
        }
        this.loadingInstance = this.$loading(LoadingOptions)
        await quesAnalyStatistics(dataParams).then(res => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })
          this.statisticsList = res
        })
      },
      // 获取考试记录列表
      async getRecordListFun(flag) {
        if(flag) this.recordsParams.pageNum = 1
        this.loadingInstance = this.$loading(LoadingOptions)
        await getRecordList(this.recordsParams).then(res => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })
          res.rows.forEach((val) => {
            val.createTime = timestampToTime(val.createTime)
            val.spendTime = secondsToMinutes(val.spendTime)
          })
          this.recordList = res.rows || []
          this.recordsCount = res.total || 0
          this.pageSize = res.pageSize || 10
          this.totalPageNum = res.totalPageNum || 1
        })
      },
      // 删除考试记录
      deleteReport (bizID) {
        let deleteParams = {
          bizID:bizID,
          flag: this.flag,
          source:'pc'
        }
        this.$confirm('此操作将永久删除该次考试, 是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loadingInstance = this.$loading(LoadingOptions)
          deleteRecord(deleteParams).then(() => {
            this.$nextTick(() => {
              this.loadingInstance.close()
            })
            this.$message.success('删除成功')
            this.getRecordListFun(true)
            this.getStatisticsList()
          })
        })
      },
     // 解析试题
     parseQuestion(row) {
        const { flag } = this.$route.params
        const { majorTag,majorID } = this.$categoryInfo
        if(flag==='huiyuan'){
            window.location.href = 'https://www.chinaacc.com/tiku/analysis/all?jkFlag='+ majorTag + '&siteCourseID='
              + this.siteCourseID + '&courseID=' + row.courseID + '&bizID=' + row.bizID + '&flag=' + flag
              + '&routerSource=examRecord' + '&routerSourcePages=' + this.recordsParams.pageNum + '' +'&majorID='+ majorID +'&from=jikao'
        }else{
          window.location.href = '//member.chinaacc.com/vqzs/analysis/allAnalysis?isExamina=1&jkFlag=' + majorTag + '&siteCourseID='
            + this.siteCourseID + '&courseID=' + row.courseID + '&paperViewID=-1&bizID=' + row.bizID + '&flag=' + flag
            + '&routerSource=examRecord' + '&routerSourcePages=' + this.recordsParams.pageNum
        }
      },
      //  重做试题
      retryQuestion(bizID) {
        this.$router.push({
          name: 'DoExam',
          query: {
            bizID: bizID.toString(),
            siteCourseID: this.siteCourseID,
            paperRedo: '1',
            courseID:this.courseID,
            routerSource: 'examRecord',
            routerSourcePages: this.recordsParams.pageNum
          }
        })
      },
      // 列表排序
      changeOrder () {
        let arr = this.orderValue.split(',')
        this.recordsParams.orderField = arr[0]
        this.recordsParams.orderType = arr[1]
        this.getRecordListFun(this.recordsParams)
      },
      // 切换页码
      handleCurrentChange(val){
        this.recordsParams.pageNum = val
        this.getRecordListFun()
      },
    }
  }
</script>
<style lang="scss" scoped>
  .exam-record {
    float:right;
    width:950px;
    min-height: 518px;
    overflow: hidden;
    .main-container {
      padding:10px 20px 0;
      background:#fff;
      border-radius:5px;
      min-height:545px;
      .main-title {
        overflow: hidden;
        padding:0 0 10px 0;
        line-height: 36px;
        font-size:14px;
        .top-left {
          float: left;
          font-weight:bold;
          span {
            color: #fd3b06;
          }
        }
        .top-right {
          float: right;
          .el-select {
            width: 100px;
            .el-input--suffix {
              .el-input__inner {
                padding: 0 15px;
              }
            }
          }
          .el-input--suffix {
            .el-input__inner {
              padding: 0 15px;
            }
          }
        }
      }
      .main-table {
        margin: 0 auto;
        font-size: 14px;
        .el-table {
          height: 416px;
          .el-table__header,
          .el-table__body {
            margin: 0 auto;
          }
        }
        .score {
          color: green;
          &:first-child {
            color: green;
          }
        }
        .el-pagination {
          margin-top:20px;
          padding-left: 20px;

        }

      }

    }
  }
</style>
<style lang="scss">
  .el-table__body {
    width: 100%;
    // 使表格兼容safari，不错位
    table-layout: fixed !important;
  }
</style>
